<template>
  <div v-if="!component">
    <div class="row">
      <div class="col-sm-2">
        <div class="form-group">
          <label for="">ID Sistema Folha:</label>
          <input
            type="text"
            class="form-control"
            id=""
            placeholder=""
            v-model="empresa.idSistemaFolha"
          />
          <!-- <p class="help-block">Este campo é obrigatório.</p> -->
        </div>
      </div>
    </div>
    <hr style="margin-top: 0;" />
    <div class="row">
      <div class="col-sm-4">
        <label>Seguro Desemprego</label>
        <hr style="margin-top: 5px;" />
        <div class="col-sm-6" style="margin: 0; padding: 0;">
          <div class="form-group">
            <label for="">Usuário:</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                :disabled="!editing"
                v-model="empresa.empregadorWebUser"
              />
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn btn-default"
                  v-btn-clipboard
                  :data-clipboard-text="empresa.empregadorWebUser"
                >
                  <i class="fa fa-clipboard"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">Senha:</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                :disabled="!editing"
                v-model="empresa.empregadorWebPassword"
              />
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn btn-default"
                  v-btn-clipboard
                  :data-clipboard-text="empresa.empregadorWebPassword"
                >
                  <i class="fa fa-clipboard"></i>
                </button>
                <button class="btn btn-primary" @click.prevent="onEditing">
                  <i class="fa fa-pencil"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-8">
        <empresa-rubricas v-model="value" @on-change="vl => (value.rubricas = vl)" />
      </div>
    </div>
  </div>
  <div v-else>
    <div class="panel panel-default">
      <div class="panel-heading" @click.prevent="collapsed = !collapsed" style="cursor: pointer;">
        <a> <i class="fa" :class="{ 'fa-plus': collapsed, 'fa-minus': !collapsed }"></i> RH </a>
      </div>
      <div class="panel-body" v-show="!collapsed">
        <div class="col-sm-12">
          <label>Seguro Desemprego</label>
          <hr style="margin-top: 5px;" />
          <div class="col-sm-6" style="margin: 0; padding: 0;">
            <div class="form-group">
              <label for="">Usuário:</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  :disabled="!editing"
                  v-model="empresaSelecionada.empregadorWebUser"
                />
                <span class="input-group-btn">
                  <button
                    type="button"
                    class="btn btn-default"
                    v-btn-clipboard
                    :data-clipboard-text="empresaSelecionada.empregadorWebUser"
                  >
                    <i class="fa fa-clipboard"></i>
                  </button>
                </span>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="">Senha:</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  :disabled="!editing"
                  v-model="empresaSelecionada.empregadorWebPassword"
                />
                <span class="input-group-btn">
                  <button
                    type="button"
                    class="btn btn-default"
                    v-btn-clipboard
                    :data-clipboard-text="empresaSelecionada.empregadorWebPassword"
                  >
                    <i class="fa fa-clipboard"></i>
                  </button>
                  <button class="btn btn-primary" @click.prevent="onEditing" v-if="!component">
                    <i class="fa fa-pencil"></i>
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EmpresaRubricas from './EmpresaRubricas.vue'
export default {
  name: 'empresa-rh',
  props: {
    value: { type: Object },
    component: { type: Boolean, default: false }
  },
  data() {
    return {
      empresa: {},
      rubrica: {
        rubrica: 'horasNormais',
        conta: 0
      },
      collapsed: true,
      editing: false
    }
  },
  mounted() {},
  methods: {
    remove(rubrica, index) {},

    onEditing() {
      this.editing = true
    }
  },
  computed: {
    empresaSelecionada() {
      return this.$store.getters.getCompany
    }
  },
  components: {
    EmpresaRubricas
  },
  watch: {
    value(vl) {
      this.empresa = vl
    }
  }
}
</script>

<style lang="css"></style>
